/**
 * PWA Standalone Detection Utility
 * 
 * Detects if the app is running in PWA standalone mode (installed as an app).
 * Safe to import in server code (returns false on server).
 * 
 * @returns true if running in standalone/installed PWA mode, false otherwise
 */
export function isStandalone(): boolean {
  // Server-side guard: always return false on server
  if (typeof window === 'undefined') {
    return false
  }

  // Check for standard PWA standalone mode (Android/Chrome)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true
  }

  // Check for iOS Safari standalone mode
  // iOS Safari sets navigator.standalone to true when in standalone mode
  const nav = navigator as any
  if (nav.standalone === true) {
    return true
  }

  return false
}

